import React from 'react';
import { styled } from 'linaria/react';
import { ProductCard } from '../CategoryPage/ProductCard';
import Slider from 'react-slick';
import { ReactComponent as Arrow } from '../../svg/Arrow.svg';
import { theme } from '../Theme';
import { Above } from '@jetshop/ui/Breakpoints';

const RelatedProductsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 80rem;
  margin: auto;
  width: 100%;
  padding: 40px 60px;
  text-align: center;

  h2 {
    color: #000;
    text-align: center;
    font-family: ${theme.fonts.primary};
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 114%; /* 27.36px */
  }

  .inner {
    display: flex;
    width: 100%;
    .product-card {
      width: calc(100% / 4);
    }
  }

  ${theme.below.lg} {
    padding: 40px 10px;
  }
`;

const CustomArrow = styled(Arrow)`
  height: 14px;
  width: 14px;
`;

const ArrowWrapper = styled('div')`
  height: 30px;
  width: 30px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  z-index: 1;
  background: white;

  &.next {
    transform: rotate(270deg);
    right: -15px;
    left: auto;
    ${theme.below.md} {
      right: 0;
    }
  }

  &.prev {
    transform: rotate(90deg);
    right: auto;
    left: -15px;
    ${theme.below.md} {
      left: 0;
    }
  }
`;

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <ArrowWrapper className={className + ' prev'} onClick={onClick}>
      <CustomArrow />
    </ArrowWrapper>
  );
}

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <ArrowWrapper className={className + ' next'} onClick={onClick}>
      <CustomArrow />
    </ArrowWrapper>
  );
}

export const RelatedProducts = ({ products }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    draggable: true,
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <RelatedProductsWrapper>
      <h2>Relaterade produkter</h2>
      <Above breakpoint="lg">
        {(matches) =>
          matches ? (
            <>
              {products?.length > 4 ? (
                <Slider {...settings}>
                  {products?.map((product, index) => (
                    <ProductCard
                      key={index + product.articleNumber}
                      product={product}
                    />
                  ))}
                </Slider>
              ) : (
                <div className="inner">
                  {products?.map((product) => {
                    return <ProductCard key={product.id} product={product} />;
                  })}
                </div>
              )}
            </>
          ) : (
            <Slider {...settings}>
              {products?.map((product, index) => (
                <ProductCard
                  key={index + product.articleNumber}
                  product={product}
                />
              ))}
            </Slider>
          )
        }
      </Above>
    </RelatedProductsWrapper>
  );
};
